import {AbstractUpload} from "./AbstractUpload";
import {Injectable} from "@angular/core";
import {Pessoa} from "../../../domain/Pessoa";
import {PessoaHttpService} from "../../persist/http/PessoaHttpService";

@Injectable()
export class UploadPessoa extends AbstractUpload<Pessoa>{
  constructor(service: PessoaHttpService) {
    super("Pessoa", service, Pessoa);
  }
}
